function NullLoader() {
	return null;
}

export default NullLoader;
